import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// DESIGN.md typography tokens. Without these, tailwind-merge cannot tell a
// size utility (text-zsd-label-lg) from a color utility (text-zsd-on-primary)
// and drops one of them.
const TYPE_TOKENS = [
  "zsd-display-xl",
  "zsd-headline-lg",
  "zsd-headline-md",
  "zsd-amount-lg",
  "zsd-body-lg",
  "zsd-body-md",
  "zsd-body-sm",
  "zsd-label-lg",
  "zsd-label-md",
  "zsd-code-md",
  "zsd-ascii-md",
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: TYPE_TOKENS }],
      "font-family": [{ font: TYPE_TOKENS }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
